const toggles = document.querySelectorAll('.toggle');

toggles.forEach((toggle) => {
    // eslint-disable-next-line no-param-reassign
    toggle.onclick = function (e) {
        this.setAttribute('data-state',
            this.getAttribute('data-state') === 'closed' ? 'open' : 'closed');

        this.nextElementSibling.setAttribute('data-state',
            this.nextElementSibling.getAttribute('data-state') === 'closed' ? 'open' : 'closed');
        e.preventDefault();
    };
});
